export default {
  loading: false,
  availableExtras: [],
};
